import './styles.css';

import { DownOutlined, EditFilled, EyeFilled, SearchOutlined } from '@ant-design/icons';
import ProductPack from '@components/ProductPack';
import ContentTable from '@components/ReferencesContentTable';
import { useReference } from '@hooks/ReferenceContext';
import { Reference } from '@models/Reference';
import { FullScreenModal } from '@styles/globals';
import { REFERENCE_PAGINATION_SIZE } from '@utils/constants';
import { Avatar, Col, Image, Row, Table, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

import ProductForm from '@components/ProductForm';
import { useIntegration } from '@hooks/IntegrationContext';
import TableFilters from '@components/TableFilters';
import ModalContentReference from '../ModalContentReference';

const { Text } = Typography;

interface ProductsTableProps {
  onlyInactives?: boolean;
}

const ProductsTable: React.FC<ProductsTableProps> = ({ onlyInactives }) => {
  const { hasMerpIntegration } = useIntegration();
  const [modalGradeIsVisible, setModalGradeIsVisible] = useState(false);
  const [modalReferenceIsVisible, setModalReferenceIsVisible] = useState(false);

  const [referencesList, setReferencesList] = useState<Reference[]>([]);
  const [currentReference, setCurrentReference] = useState<Reference>({} as Reference);

  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  const [modalNewProductVisible, setModalNewProductVisible] = useState(false);

  const {
    references,
    referencesFilters,
    loadingReferences,
    loadReferencePack,
    loadingReferencePack,
    referencePack,
    updateReferencePack,
    referencesCurrentPage,
    referencesTotalPages,
    loadReferences,
    updateReferenceStatus,
    loadReferenceProducts,
  } = useReference();

  const showNewProductModal = useCallback(
    (reference: Reference) => {
      setCurrentReference(reference);
      setModalNewProductVisible(true);
    },
    [setCurrentReference, setModalNewProductVisible],
  );

  const onCloseNewProductModal = () => {
    setModalNewProductVisible(false);
  };

  const handleShowModalGrade = useCallback(
    async (reference: Reference) => {
      setCurrentReference(reference);
      loadReferencePack(reference.ReferenceCode);
      setModalGradeIsVisible(true);
    },
    [setCurrentReference, loadReferencePack, setModalGradeIsVisible],
  );

  const onCloseModalGrade = useCallback(() => {
    setModalGradeIsVisible(false);
  }, [setModalGradeIsVisible]);

  const onShowModalReference = useCallback(() => {
    setModalReferenceIsVisible(true);
  }, [setModalReferenceIsVisible]);

  const onCloseModalReference = useCallback(() => {
    setModalReferenceIsVisible(false);
  }, [setModalReferenceIsVisible]);

  const handleReferenceClick = useCallback(
    (reference: Reference) => {
      setCurrentReference(reference);
      onShowModalReference();
    },
    [setCurrentReference, onShowModalReference],
  );

  useEffect(() => {
    if (onlyInactives) {
      setReferencesList(references?.filter((_reference: Reference) => !_reference.isActive));
    } else {
      setReferencesList(references?.filter((_reference: Reference) => _reference.isActive));
    }
  }, [references]);

  const getReferenceImage = (photoUrl: string, name: string) => {
    if (photoUrl)
      return (
        <Image
          src={photoUrl}
          width={30}
          style={{ borderRadius: '12px' }}
          preview={false}
          fallback="data:image/png;base64,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"
        />
      );

    return <Avatar style={{ backgroundColor: 'var(--primary-color)', verticalAlign: 'middle' }}>{name[0]}</Avatar>;
  };

  const columns = [
    {
      title: 'Referência',
      render: (reference: Reference): JSX.Element => (
        <div>
          {getReferenceImage(reference.photoUrl, reference.name)}
          <Text className="ml-3">{reference.ReferenceCode}</Text>
        </div>
      ),
      ellipsis: true,
      sorter: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder="Filtrar pela Referência"
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined style={{ color: '#FFFFFF' }} />,
      onFilter: (value: any, record: Reference) =>
        record.ReferenceCode ? record.ReferenceCode.toLowerCase().includes(String(value).toLowerCase()) : false,
    },
    {
      title: 'Descrição',
      dataIndex: 'name',
      ellipsis: true,
      sorter: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Descrição'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.name ? record.name.toString().toLowerCase().includes(value.toLowerCase()) : false;
      },
    },
    {
      title: 'Tamanhos',
      dataIndex: 'grid',
      render: (sizes: string[]): JSX.Element => (
        <Text>{sizes?.map((size: string, i: number) => (i === 0 ? size : ' | ' + size))}</Text>
      ),
      ellipsis: true,
    },
    {
      title: 'Qtde. de Itens',
      dataIndex: 'itemQty',
      align: 'right' as 'right',
    },
    {
      title: 'Grade/Pack',
      align: 'center' as 'center',
      render: (_reference: Reference): JSX.Element => {
        return (
          <div onClick={() => handleShowModalGrade(_reference)} style={{ cursor: 'pointer' }}>
            <span style={{ color: '#510c76', fontWeight: 'bold' }}>Grade</span>
            <DownOutlined style={{ fontSize: '16px', marginLeft: '8px', color: '#510c76' }} />
          </div>
        );
      },
    },
    {
      title: 'Ações',
      align: 'center' as 'center',
      render: (reference: Reference): JSX.Element => {
        return (
          <>
            <EyeFilled onClick={() => handleReferenceClick(reference)} style={{ fontSize: '24px', color: '#510c76' }} />
            {hasMerpIntegration && (
              <EditFilled
                onClick={() => showNewProductModal(reference)}
                style={{ fontSize: '24px', color: '#510c76', paddingLeft: 15 }}
              />
            )}
          </>
        );
      },
    },
  ];

  const onChangeRowSelection = async (reference: Reference) => {
    updateReferenceStatus(reference.ReferenceCode, !reference.isActive);
  };

  const rowSelection = {
    columnTitle: ' ',
    selectedRowKeys: references?.map((_reference: Reference) => (_reference.isActive ? _reference.ReferenceCode : '0')),
    onSelect: onChangeRowSelection,
  };

  const onTableRowExpand = (expanded: boolean, reference: Reference) => {
    const keys = [];

    if (expanded) {
      keys.push(reference.ReferenceCode);
    }

    setExpandedRowKeys(keys);

    if (expanded) return loadReferenceProducts(reference.ReferenceCode);
  };

  const handlePaginationChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column') && sorter.field !== 'itemQty') {
      if (sorter.field === undefined) sorter.field = 'ReferenceCode';
      referencesFilters.field = `${sorter.field}`;
      referencesFilters.order = `${sorter.order}`;
    }

    const actives: boolean = !onlyInactives;
    loadReferences(pagination.current, actives, referencesFilters);
  };

  return (
    <>
      <FullScreenModal
        destroyOnClose={true}
        visible={modalNewProductVisible}
        onOk={onCloseNewProductModal}
        onCancel={onCloseNewProductModal}
        footer={null}
        forceRender={false}
      >
        <Row align="middle" justify="center">
          <Col span={24} className="d-flex" style={{ width: '1000px' }}>
            <ProductForm onCloseModal={onCloseNewProductModal} isEditing={true} referenceToEdit={currentReference} />
          </Col>
        </Row>
      </FullScreenModal>

      <Table
        scroll={{ x: 800 }}
        className="table-products"
        columns={columns}
        dataSource={referencesList}
        rowSelection={rowSelection}
        rowKey={(record) => record.ReferenceCode}
        expandable={{
          expandedRowRender: () => <ContentTable />,
          onExpand: onTableRowExpand,
        }}
        expandedRowKeys={expandedRowKeys}
        pagination={{
          total: referencesTotalPages,
          current: referencesCurrentPage,
          pageSize: REFERENCE_PAGINATION_SIZE,
          showSizeChanger: false,
        }}
        onChange={handlePaginationChange}
        loading={loadingReferences}
      />

      <FullScreenModal
        destroyOnClose={true}
        visible={modalGradeIsVisible}
        onOk={onCloseModalGrade}
        onCancel={onCloseModalGrade}
        footer={null}
        forceRender={false}
        bodyStyle={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10% 15%',
        }}
      >
        <ProductPack
          colors={referencePack?.colors}
          sizes={referencePack?.sizes}
          loading={loadingReferencePack}
          isPack={currentReference.isPack}
          onSubmit={(values: any) => updateReferencePack(currentReference.ReferenceCode, values)}
          packs={referencePack?.packs}
        />
      </FullScreenModal>

      <FullScreenModal
        destroyOnClose={true}
        footer={null}
        forceRender={false}
        visible={modalReferenceIsVisible}
        onCancel={onCloseModalReference}
        onOk={onCloseModalReference}
        bodyStyle={{ width: '100%' }}
      >
        <ModalContentReference reference={currentReference} />
      </FullScreenModal>
    </>
  );
};

export default ProductsTable;
